/**
 * 新闻稿**预览页 meta 行**那枚「AI 生成内容标识」小标签的显隐开关。
 *
 * 老板 2026-08-19 原话:「我说的是**文章标题下面那个由 ai 生成的标志**」——「**先隐藏**」。
 * 用开关而不是删掉那段 JSX:说的是"先",将来要放回来时改这一处就行,不用再去找。
 *
 * ═══ 这个开关管什么、不管什么(三句,别扩大适用)═════════════════════════════
 *
 * ① **它只关一个东西**:`ReporterPreviewPage` 文章 meta 行里、与租户名/日期/字数并排的
 *    那枚圆角小标签「AI 生成内容标识」。就是老板说的"标题下面那个"。
 *
 * ② **下面这些不受它控制,也不许接进来**:
 *    · 封面图左下角那句「封面 · 视觉舱生成 · 已计入 AIGC 标识」—— 它不在标题下面,老板没点它;
 *      而且它本身不是标识,是在**告诉运营"图上已经有标识了"**,关掉等于让运营不再被告知。
 *    · 导出的 Word / Markdown、复制公众号格式的正文 —— 这些**本来就不含任何 AI 声明**。
 *    · 图片像素里烧进去的 AIGC 角标(视觉舱 SERVER_OVERLAY)、以及文件元数据里的隐式标识。
 *
 * ③ **为什么不能顺手把 ② 里那些也接进来**:②的后三项都会**离开平台**,涉及"对外是否声明
 *    AI 生成"。中国《人工智能生成合成内容标识办法》(2025-09-01 起施行)+ GB 45438-2025
 *    要求 AI 生成图/视频带**隐式(文件元数据)+ 显式(可见提示)**标识。**这是合规面,要老板
 *    单独拍,不能由一个"界面清爽"的需求顺带决定。** 尤其隐式元数据那一半:它根本不可见,
 *    关掉对"界面清爽"零帮助、只有风险。
 *
 * ★现状值得记一笔(已单独报,等老板拍):导出产物正文对外一个字都不声明 ⇒ 现在"对外声明"
 *   这件事**完全靠图上那个角标撑着**。所以 ② 的第三项尤其不能顺手动。
 */
export const SHOW_PREVIEW_AIGC_LABEL = false;

/**
 * ★1011 算法备案(《标识办法》+ GB 45438 显式标识)改口径:这枚标签由租户合规配置
 * `compliance.visibleLabel` 决定(1011 拍板全局默认关 = 默认仍隐藏,与 0819 一致;备案租户打开后显示)。上面的 0819「先隐藏」常量只留作历史
 * 记录,**页面不再读它**;页面一律走 {@link showPreviewAigcLabel}。管辖范围仍是 ① 那一枚标签,② 不变。
 */
export function showPreviewAigcLabel(visibleLabel: boolean): boolean {
  return visibleLabel;
}

/** 标签文案。单独抽出来,判据钉的是同一个字面量,不会两边各写一份而漂开。 */
export const PREVIEW_AIGC_LABEL_TEXT = "AI 生成内容标识";
